import { useEffect, useState } from "react";
import { api, PHONE, PHONE_INTL, EMAIL, COMPANY } from "../lib/api";
import { useSEO } from "../lib/useSEO";
import { Reveal } from "../components/Reveal";
import { Breadcrumbs } from "../components/Shared";
import { PhoneBox } from "../components/Layout";
import ContactForm from "../components/ContactForm";
import { Phone, Mail, Clock, MapPin } from "lucide-react";

export default function Contact() {
  const [services, setServices] = useState([]);
  const [cities, setCities] = useState([]);
  useSEO({ title: `Contact & Devis gratuit — ${COMPANY} (77)`, description: `Contactez votre serrurier en Seine-et-Marne pour un devis gratuit ou une intervention d'urgence 7j/7 ☎ ${PHONE}.`, path: "/contact" });
  useEffect(() => {
    api.get("/services").then(r => setServices(r.data)).catch(() => {});
    api.get("/cities").then(r => setCities(r.data)).catch(() => {});
  }, []);

  return (
    <div className="bg-white">
      <section className="relative pt-32 pb-16 sm:pt-36 hero-grid">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <Breadcrumbs items={[{ label: "Accueil", to: "/" }, { label: "Contact" }]} />
          <Reveal>
            <p className="overline mb-4">Devis gratuit & urgences</p>
            <h1 className="text-4xl sm:text-6xl font-display font-semibold tracking-tighter leading-[0.95] max-w-3xl text-zinc-900">Parlons de votre besoin</h1>
            <p className="text-lg text-zinc-600 mt-8 max-w-2xl leading-relaxed">Pour une urgence, le plus rapide reste l'appel. Sinon, remplissez le formulaire : nous revenons vers vous avec un devis clair et gratuit.</p>
            <div className="mt-8"><PhoneBox /></div>
          </Reveal>
        </div>
      </section>

      <section className="relative z-10 pb-28 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-[1fr_1.3fr] gap-14 items-start">
          <Reveal className="space-y-5">
            <a href={`tel:${PHONE_INTL}`} className="block card-soft rounded-2xl bg-primary p-7 shadow-xl shadow-primary/20 text-white">
              <Phone className="h-6 w-6 mb-3" />
              <p className="text-[10px] font-mono uppercase tracking-widest text-white/70 mb-1">Téléphone · 7j/7 24h/24</p>
              <span className="font-display font-semibold text-3xl tracking-tighter">{PHONE}</span>
            </a>
            <div className="card-soft rounded-2xl border border-zinc-200 bg-white p-7 shadow-sm"><Mail className="h-6 w-6 text-primary mb-3" /><p className="overline mb-1 !text-zinc-400">Email</p><span className="text-zinc-800">{EMAIL}</span></div>
            <div className="card-soft rounded-2xl border border-zinc-200 bg-white p-7 shadow-sm"><Clock className="h-6 w-6 text-primary mb-3" /><p className="overline mb-1 !text-zinc-400">Horaires</p><span className="text-zinc-800">7j/7 · 24h/24 · jours fériés inclus</span></div>
            <div className="card-soft rounded-2xl border border-zinc-200 bg-white p-7 shadow-sm"><MapPin className="h-6 w-6 text-primary mb-3" /><p className="overline mb-1 !text-zinc-400">Zone</p><span className="text-zinc-800">Toute la Seine-et-Marne (77)</span></div>
          </Reveal>
          <Reveal delay={0.1}><ContactForm services={services} cities={cities} /></Reveal>
        </div>
      </section>
    </div>
  );
}
